import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'cp-page-not-found',
  template: `<div class="page-not-found">
    <div class="page-not-found__icon">
      <ui-svg-icon
        svgId="alert"
        iconClassName="icon-page-not-found--icon"
      ></ui-svg-icon>
    </div>
    <h1>Oops, Page Not Found!</h1>
    <a class="text-link" routerLink="/">Go Home</a>
  </div>`,
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
})
export class PageNotFoundComponent {
  constructor() {}
}
